import { useEffect } from 'react';
import { useQuill } from 'react-quilljs';
import BlotFormatter from '@enzedonline/quill-blot-formatter2';
import "quill/dist/quill.core.css";
import 'quill/dist/quill.snow.css';

const Editor = ({ content, handleSave }) => {

  const { quill, quillRef, Quill } = useQuill({    
  });

  if (Quill && !quill) {
    //var ColorClass = Quill.import('attributors/class/color');
    //var SizeStyle = Quill.import('attributors/style/size');    
    Quill.register('modules/blotFormatter', BlotFormatter);
  }

  useEffect(() => {
    if (quill) {
        quill.clipboard.dangerouslyPasteHTML(content);
    }
  }, [quill, Quill, content]);

  return (
    <div className=''>
      <div ref={quillRef} />
      <div className='controls'>
      <div className='button' onClick={()=>{
        var justHtml = quill.root.innerHTML;
      
        if(!handleSave)return;
        
        handleSave(justHtml)

      }}>Save</div>
    </div>
    </div>
  );
};

export default Editor;
